@if (rules().length > 0 || minimumLength() > 0) {
  <div class="progress-outer password-meter">
    <span>{{ 'passwort_meter.text.description_rules' | translate }}</span>
    <ul>
      @for (rule of rules(); track rule) {
        <li class="password-meter__item" [class.match-rule]="isRuleMatched(rule)">
          {{ rule.text ?? 'passwort_meter.description_rules.unknown_rule' | translate }}
        </li>
      }
      @if (minimumLength()) {
        <li class="password-meter__item" [class.match-rule]="length >= minimumLength()">
          {{ 'passwort_meter.rule_description.min_length' | translate: { min: minimumLength() } }}
        </li>
      }

      @if (maximumLength() < 40) {
        <li class="password-meter__item" [class.match-rule]="length > 0 && length <= maximumLength()">
          {{ 'passwort_meter.rule_description.max_length' | translate: { max: maximumLength() } }}
        </li>
      }
    </ul>
  </div>
}
